import { useRef, useState } from 'react';
import MoreIcon from '@material-ui/icons/MoreVert';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@material-ui/core';

const MoreActions = ({ moreActions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRef = useRef(null);

  const handleClose = () => setAnchorEl(null);

  return (
    <div ref={anchorRef}>
      <IconButton
        color="secondary"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        disableScrollLock
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {moreActions.map((action, i) => (
          <MenuItem
            key={`more-list-item-${i}`}
            onClick={(e) => {
              handleClose();
              action.onClick(e);
            }}
          >
            {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
            {action.label && <ListItemText>{action.label}</ListItemText>}
            {action.badgeContent > 0 && (
              <Chip label={action.badgeContent} size="small" />
            )}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MoreActions;
